import styled from 'styled-components';
import * as React from 'react';
import { DSWell } from '../../mui';
import { ReportSectionProps, ReportSection } from '../ReportSection';

export interface ReportWellProps extends Omit<ReportSectionProps, 'padChildren' | 'titleVariant'> {
    children?: React.ReactNode;
}
export const StyledReportWell: React.FC<ReportWellProps> = styled(DSWell)`
    position: relative;

    padding-top: 15px;

    margin-bottom: 20px;

    @media print {
        page-break-inside: avoid;

        border-top: #7e7e7e 1px solid;
        border-bottom: #7e7e7e 1px solid;
    }
`;

export const ReportWell: React.FunctionComponent<ReportWellProps> = props => (
    <StyledReportWell>
        <ReportSection padChildren={false} titleVariant="h4" {...props} />
    </StyledReportWell>
);
ReportWell.displayName = 'ReportWell';
